import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.object.to-string.js";
import { mapState } from 'vuex';
import { updateModule } from '@/api/setting/modular';
export default {
  props: {
    id: {},
    data: {}
  },
  name: 'edit',
  computed: _objectSpread({}, mapState('cpscc', ['staffsList'])),
  data: function data() {
    return {
      form: {
        Control: undefined,
        MangerStaffs: [],
        QueryStaffs: []
      },
      rules: {},
      loading: false
    };
  },
  methods: {
    selectedChange: function selectedChange(val, key) {
      var res = val.find(function (item) {
        return item === '*';
      });
      if (res) {
        this.form[key] = ['*'];
      }
    },
    cancel: function cancel() {
      this.$emit('cancel');
    },
    submit: function submit() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var data, _yield$_this$$awaitTo, _yield$_this$$awaitTo2, err;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              data = {
                ModuleId: _this.id,
                MangerStaffs: '',
                QueryStaffs: '',
                Control: 0
              }; // 所有人都可以查看/编辑
              if (!_this.form.MangerStaffs.length && !_this.form.QueryStaffs.length) {
                data.Control = 0;
              }
              // 启用查看权限控制
              if (_this.form.QueryStaffs.length && !_this.form.MangerStaffs.length) {
                data.Control = 1;
              }
              // 启用查看 / 编辑 权限控制
              if (_this.form.MangerStaffs.length) {
                data.Control = 2;
              }
              if (_this.form.MangerStaffs.length) {
                data.MangerStaffs = _this.form.MangerStaffs.join('/');
              }
              if (_this.form.QueryStaffs.length) {
                data.QueryStaffs = _this.form.QueryStaffs.join('/');
              }
              _this.loading = true;
              _context.n = 1;
              return _this.$awaitTo(updateModule(_objectSpread({}, data)));
            case 1:
              _yield$_this$$awaitTo = _context.v;
              _yield$_this$$awaitTo2 = _slicedToArray(_yield$_this$$awaitTo, 1);
              err = _yield$_this$$awaitTo2[0];
              _this.loading = false;
              if (!err) {
                _context.n = 2;
                break;
              }
              return _context.a(2);
            case 2:
              _this.$message.success('操作成功');
              _this.$emit('submit');
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }))();
    }
  },
  created: function created() {
    this.form.Control = this.data.n99Control;
    this.form.MangerStaffs = this.data.n99MangerStaffs.split('/').filter(function (item) {
      return item;
    });
    this.form.QueryStaffs = this.data.n99QueryStaffs.split('/').filter(function (item) {
      return item;
    });
  }
};